import { useTranslation } from 'next-i18next';
import { type YoutubeVideoData } from '@/api/ai/youtube/types';
import { type AiLoadingState } from './aiLoadingMessages.const';
import { AiGeneratingPending } from './Base';
type Props = {
  youtubeData?: YoutubeVideoData;
  loadingState: Omit<AiLoadingState, 'sourceType'>;
};
export const AiGeneratingPendingByYoutube = ({
  youtubeData,
  loadingState
}: Props) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiGeneratingPending imageSrc={'/assets/ai_generating_v2.webp'} prompt={youtubeData?.title ? t('build:ai.file.generatingByYoutube', {
    title: youtubeData.title
  }) : undefined} loadingState={{
    ...loadingState,
    sourceType: 'youtube'
  }} data-sentry-element="AiGeneratingPending" data-sentry-component="AiGeneratingPendingByYoutube" data-sentry-source-file="AiGeneratingPendingByYoutube.tsx" />;
};